import api from "../../../../../api";

export const requestGetUserFilters = () => {
  return api.get("/userfiltersuser");
};
